var exports = {
  "k": "x93eb46d8--204edf--container",
  "X": "x93eb46d8--204edf--scroller",
};

module.exports = exports;
